import { requiredIfNotExpectedComparerValue, isTrue } from "@utilities";

export const STEP_2_VALIDATIONS = [
  {
    field: "clientPlanServices.0.data.clientPlanServicesCard",
    validation: isTrue
  },
  {
    field: "companyFunds.0.data.otherInput",
    compareField: "companyFunds.0.data.other",
    validation: requiredIfNotExpectedComparerValue([false, "0", "", undefined])
  }
];
